import { render, staticRenderFns } from "./MdrlImport.vue?vue&type=template&id=767815cf&scoped=true&"
import script from "./MdrlImport.vue?vue&type=script&lang=js&"
export * from "./MdrlImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767815cf",
  null
  
)

export default component.exports